// src/APIs/insurancePlanUI.js
import axios from "axios";

const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/api/v1/admin/insurance-plans`;

export async function fetchInsurancePlans() {
  const res = await axios.get(BASE_URL);
  return res.data;
}

export async function createInsurancePlan(plan) {
  // plan should have: planId, planName, planTypes[]
  const res = await axios.post(BASE_URL, plan);
  return res.data;
}

export async function updateInsurancePlan(id, plan) {
  // PUT request for updates
  const res = await axios.put(`${BASE_URL}/${id}`, plan);
  return res.data;
}

export async function deleteInsurancePlan(id) {
  await axios.delete(`${BASE_URL}/${id}`);
}
